<template>
  <div class="myinfo">
    <form class="form-horizontal">
       <div class="form-group row">
          <label class="col-md-1 control-label">学校</label>
          <div class="col-md-11">
            <input type="text" class="form-control" disabled="disabled" v-model="userInfo.eduName" >
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-1 control-label">账户</label>
          <div class="col-md-11">
            <input type="text" class="form-control" disabled="disabled" v-model="userInfo.username" >
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-1 control-label">姓名</label>
          <div class="col-md-11">
            <input type="text" class="form-control" disabled="disabled" v-model="userInfo.name" >
          </div>
        </div>
        <div class="form-group row">
          <label  class="col-md-1 control-label">性别</label>
          <div class="col-md-11">
            <input type="text" class="form-control "   disabled="disabled" :value="[ '','男', '女'][userInfo.sex]">
          </div>
        </div>
      <div class="form-group row">
        <label  class="col-md-1 control-label">专业</label>
        <div class="col-md-11">
          <input type="text" class="form-control " disabled="disabled"  v-model="userInfo.proName">
        </div>
      </div>
      <div class="form-group row">
        <label  class="col-md-1 control-label">学制</label>
        <div class="col-md-11">
          <input  type="text" class="form-control border-none" disabled="disabled" v-model="userInfo.proSystem">
        </div>
      </div>
      <div class="form-group row">
        <label  class="col-md-1 control-label">专业层次</label>
        <div class="col-md-11">
          <input  type="text" class="form-control"  disabled="disabled" v-model="userInfo.learnLevel">
        </div>
      </div>
      <div class="form-group row">
        <label  class="col-md-1 control-label">学号</label>
        <div class="col-md-11">
          <input  type="text" class="form-control" disabled="disabled" v-model="userInfo.studentNo">
        </div>
      </div>
      <div class="form-group row">
        <label  class="col-md-1 control-label">身份证号</label>
        <div class="col-md-11">
          <input type="text" class="form-control"  disabled="disabled" v-model="userInfo.idNo">
        </div>
      </div>
      <div class="form-group row">
        <label  class="col-md-1 control-label">移动电话</label>
        <div class="col-md-11 edit-item" v-if="!phoneInputShow">
          <div class="content-text" v-if="userInfo.phone">{{ userInfo.phone }}</div><a-icon type="edit" style="color: #1890FF" @click="handlePhoneEdit" />
        </div>
        <!-- <div class="col-md-11 edit-item" v-else>
          <input  type="text" class="form-control" style="width: 200px;" v-model="phone"><a-icon type="close" style="color: #FF4D4F" @click="phoneInputShow = false" /><a-icon type="check" style="color: #52C41A" @click="handlePhoneSubmit" />
        </div> -->
      </div>
      <div class="form-group row">
        <label  class="col-md-1 control-label">邮箱</label>
        <div class="col-md-11 edit-item" v-if="!emailInputShow">
         <div class="content-text" v-if="userInfo.email">{{ userInfo.email }}</div><a-icon type="edit" style="color: #1890FF" @click="handleEmailEdit" />
        </div>
        <div class="col-md-11 edit-item" v-else>
          <input  type="text" class="form-control" style="width: 200px;" v-model="email"><a-icon type="close" style="color: #FF4D4F" @click="emailInputShow = false" /><a-icon type="check" style="color: #52C41A" @click="handleEmailSubmit" />
        </div>
      </div>
      <div class="form-group row">
        <label  class="col-md-1 control-label">籍贯</label>
        <div v-if="!nativeplaceShow" class="col-md-11 edit-item">
          <div class="content-text" v-if="userInfo.nativeplace">{{ userInfo.nativeplace }}</div><a-icon type="edit" style="color: #1890FF" @click="handlePlaceEdit" />
        </div>
        <div class="col-md-11 edit-item" v-else>
          <input  type="text" class="form-control" style="width: 300px;" v-model="nativeplace"><a-icon type="close" style="color: #FF4D4F" @click="nativeplaceShow = false" /><a-icon type="check" style="color: #52C41A" @click="handlePlaceSubmit" />
        </div>
      </div>
      <div class="form-group row">
        <label  class="col-md-1 control-label">通讯地址</label>
        <div v-if="!addressShow" class="col-md-11 edit-item">
         <div class="content-text" v-if="userInfo.address">{{ userInfo.address }}</div><a-icon type="edit" style="color: #1890FF" @click="handleAddressEdit" />
        </div>
        <div class="col-md-11 edit-item" v-else>
          <input  type="text" class="form-control" style="width: 300px;" v-model="address"><a-icon type="close" style="color: #FF4D4F" @click="addressShow = false" /><a-icon type="check" style="color: #52C41A" @click="handleAddressSubmit" />
        </div>
      </div>
      <div class="form-group row" v-if="$store.state.homeObj.show_site_info == '1'">
          <label class="form-label">教学点名称</label>
          <div class="col-md-10">
            <input type="text" class="form-control" disabled="disabled" v-model="userInfo.siteName" >
          </div>
        </div>
        <div class="form-group row" v-if="$store.state.homeObj.show_site_info == '1'">
          <label class="form-label">教学点电话</label>
          <div class="col-md-10">
            <input type="text" class="form-control" disabled="disabled" v-model="sitePhone" >
          </div>
        </div>
        <!-- <div class="form-group row">
          <label class="col-md-2 control-label">学院名称</label>
          <div class="col-md-10">
            <input type="text" class="form-control" disabled="disabled" v-model="userInfo.sitePhone" >
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-2 control-label">学院联系方式</label>
          <div class="col-md-10">
            <input type="text" class="form-control" disabled="disabled" v-model="userInfo.sitePhone" >
          </div>
        </div> -->
    </form>
      <!-- 更改手机号弹框 -->
    <a-modal
      :visible="showBindTel"
      title="修改手机号"
      width="600px"
      destroyOnClose
      :maskClosable="false"
      :closable="true"
      :okButtonProps="{style: { background: '#2CAF7A', border: '#2CAF7A' }}"
      @cancel="showBindTel = false"
      @ok="onPhoneCodeSubmit"
    >
      <ChangeBindTel ref="telComponent" @toggle-modal="handleTogglePnoneModal" :id="userInfo.id" :oldPhone="maskPhone(userInfo.phone)" :originPhone="userInfo.phone" ></ChangeBindTel>
    </a-modal>
     <!-- 绑定手机号弹框 -->
    <a-modal
      :visible="showBindNewTel"
      title="绑定手机号"
      width="600px"
      destroyOnClose
      :maskClosable="false"
      :closable="true"
      :okButtonProps="{style: { background: '#2CAF7A', border: '#2CAF7A' }}"
      @cancel="showBindNewTel = false"
      @ok="onBindPhoneSubmit"
    >
      <NoneTelBind ref="bindTelComponent" @toggle-modal="handleToggleBindPhoneModal" :id="userInfo.id" :username="userInfo.username" ></NoneTelBind>
    </a-modal>
      <!-- 更改邮箱弹框 -->
      <a-modal
      :visible="showBindEmail"
      title="修改邮箱"
      width="600px"
      destroyOnClose
      :maskClosable="false"
      :closable="true"
      :okButtonProps="{style: { background: '#2CAF7A', border: '#2CAF7A' }}"
      :confirmLoading="confirmLoading"
      @cancel="showBindEmail = false"
      @ok="handleEmailCodeSubmit"
    >
      <ChangeBindEmail ref="emailComponent" @toggle-modal="handleToggleModal"></ChangeBindEmail>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ChangeBindTel from "./ChangeBindTel.vue";
import NoneTelBind from "./noneTelBind.vue";
import ChangeBindEmail from "./ChangeBindEmail.vue";
export default {
  name: 'MyInfo',
  props: {
    arrs: Array
  },
  components: { ChangeBindTel, ChangeBindEmail, NoneTelBind },
  data: function () {
    return {
      phoneInputShow: false,
      phone: '',
      emailInputShow: false,
      email: '',
      nativeplaceShow: false,
      nativeplace: '',
      addressShow: false,
      address: '',
      showBindTel: false,
      showBindNewTel: false,
      showBindEmail: false,
      confirmLoading: false,
      sitePhone: ''
    }
  },
    computed: {
    ...mapState(["userInfo"]),
  },
  created(){
    if(this.$route.name !== 'myPersonalStudyFee'&&localStorage.getItem('token')){
      this.axios.get('/sys/login/userinfo').then(res=>{
        let userInfo = res.result.userInfo
        userInfo.eduLogo = res.result.eduLogo || null
        userInfo.headTitle = res.result.headTitle
        userInfo.pageTitle = res.result.pageTitle
        document.title = `${userInfo.eduName} - ${userInfo.pageTitle}`
        this.common.setStorage('userInfo', userInfo)
        this.$store.commit('SET_USERINFO', userInfo)
        console.log('userInfo 个人中心')
        this.phoneInputShow = false
        this.emailInputShow = false
        this.addressShow = false
        this.nativeplaceShow = false
      })
    }
    this.sitePhone=this.userInfo.sitePhone.replace(/<br>/g, ' ')
  },
  methods: {
    maskPhone(phone) {
      // 处理非字符串输入
      if (typeof phone !== 'string') return phone
      // 仅当长度为11时进行掩码处理
      return phone.length === 11 ? phone.substring(0, 3) + '****' + phone.substring(7) : phone
    },

    handlePhoneEdit () {
      if (this.userInfo.phone) {
        this.showBindTel = true
      } else {
        this.showBindNewTel = true
      }
    },
    onPhoneCodeSubmit() {
      this.$refs.telComponent.submit()
    },
    onBindPhoneSubmit() {
      this.$refs.bindTelComponent.submit()
    },
    handlePhoneSubmit () {
      const myregPhone = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/
      if (!this.phone) {
        this.$message.warning('请输入手机号')
        return false
      } else if (!myregPhone.test(this.phone)) {
        this.$message.warning('手机号格式不正确')
        return false
      }
      const params = {
        id: this.userInfo.id,
        phone: this.phone
      }
      this.axios.put('/biz/archive/stuEdit', params).then(res => {
        if (res.success) {
          this.axios.get('/sys/login/userinfo').then(res=>{
        let userInfo = res.result.userInfo
        userInfo.eduLogo = res.result.eduLogo || null
        userInfo.headTitle = res.result.headTitle
        this.common.setStorage('userInfo', userInfo)
        this.$store.commit('SET_USERINFO', userInfo)
        console.log('userInfo 个人中心')
        this.phoneInputShow = false
      })
          this.$message.success('修改成功')
        }
      })
    },
    handleEmailEdit () {
      // this.emailInputShow = true
      // this.email = this.userInfo.email
      this.showBindEmail = true
    },
    handleEmailCodeSubmit () {
      this.$refs.emailComponent.verificationImage()
    },
    handleToggleModal(data) {
      this.showBindEmail = data.visable
      this.confirmLoading = data.Loading
    },
    handleTogglePnoneModal(show) {
      this.showBindTel = show
    },
    handleToggleBindPhoneModal(show) {
      this.showBindNewTel = show
    },
    handleEmailSubmit () {
      const myregEmail = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
      if (!this.email) {
        this.$message.warning('请输入邮箱')
        return false
      } else if (!myregEmail.test(this.email)) {
        this.$message.warning('邮箱格式不正确')
        return false
      }
      const params = {
        id: this.userInfo.id,
        email: this.email
      }
      this.axios.put('/biz/archive/stuEdit', params).then(res => {
        if (res.success) {
          this.axios.get('/sys/login/userinfo').then(res=>{
        let userInfo = res.result.userInfo
        userInfo.eduLogo = res.result.eduLogo || null
        userInfo.headTitle = res.result.headTitle
        this.common.setStorage('userInfo', userInfo)
        this.$store.commit('SET_USERINFO', userInfo)
        console.log('userInfo 个人中心')
        this.emailInputShow = false
      })
          this.$message.success('修改成功')
        }
      })
    },
    handlePlaceEdit () {
      this.nativeplaceShow = true
      this.nativeplace = this.userInfo.nativeplace
    },
    handlePlaceSubmit () {
      if (!this.nativeplace) {
        this.$message.warning('请输入籍贯')
        return false
      }
      const params = {
        id: this.userInfo.id,
        nativeplace: this.nativeplace
      }
      this.axios.put('/biz/archive/stuEdit', params).then(res => {
        if (res.success) {
          this.axios.get('/sys/login/userinfo').then(res=>{
        let userInfo = res.result.userInfo
        userInfo.eduLogo = res.result.eduLogo || null
        userInfo.headTitle = res.result.headTitle
        this.common.setStorage('userInfo', userInfo)
        this.$store.commit('SET_USERINFO', userInfo)
        this.nativeplaceShow = false
      })
          this.$message.success('修改成功')
        }
      })
    },
    handleAddressEdit () {
      this.addressShow = true
      this.address = this.userInfo.address
    },
    handleAddressSubmit () {
      if (!this.address) {
        this.$message.warning('请输入通讯地址')
        return false
      }
      const params = {
        id: this.userInfo.id,
        address: this.address
      }
      this.axios.put('/biz/archive/stuEdit', params).then(res => {
        if (res.success) {
          this.axios.get('/sys/login/userinfo').then(res=>{
         let userInfo = res.result.userInfo
         userInfo.eduLogo = res.result.eduLogo || null
         userInfo.headTitle = res.result.headTitle
         this.common.setStorage('userInfo', userInfo)
         this.$store.commit('SET_USERINFO', userInfo)
         console.log('userInfo 个人中心')
         this.addressShow = false
       })
          this.$message.success('修改成功')
          
        }
      })
    },
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/mixins.styl'
  .border-none{
    border:0;
  }
  .myinfo{
    background:$bgcontent;
    padding:28px;
    margin-left:20px;
    margin-right:28px;
    .form-horizontal{
       background:#fff;
        padding:28px;
        .form-group {
          margin-bottom: 8px;
        }
    }
    .col-md-1{
      padding-right:0;
    }
    .form-control:disabled{
      background:none;
      border:none;
    }
    label{
      margin-top:10px;
      color:#999;
    }
    h1{
      border-bottom:1px solid #efefef;
      font-size:16px;
      font-weight:bold;
      margin-bottom:20px;
    }
    .btn{
      background: $bgColor;
      color:#fff;
      width:80px;
    }
  }
  .form-label {
    padding: 0 15px;
    margin: 10px 0 7.5px 0;
  }
  .edit-item {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .content-text {
    padding: 0 14px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/MyInfo.vue